import { Serializable } from '@admin/core/models/serializable';
import { TreeTableNode } from './tree-table-node';
import { MonthlyPlanReportPortfolioDetails } from './monthly-plan-report-portfolio-details';
import { MonthlyPlanReportOverview } from './monthly-plan-report-overview';

export class MonthlyPlanReport implements Serializable<MonthlyPlanReport> {
  public monthOverview: MonthlyPlanReportOverview;
  public tableData: TreeTableNode[];
  public portfolioDetails: { [id: number]: MonthlyPlanReportPortfolioDetails };

  fromObject(object: any): MonthlyPlanReport {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
}
